module.exports = __webpack_public_path__ + "static/media/trend-portfolio bg4.14b341a2.png";